// src/components/TrustSection.js
import React from 'react';
import { Icon } from '@iconify/react';
import './TrustSection.css';

const TrustSection = () => {
    return (
        <section className="trust">
            <div className="trust__container">
                
                {/* Intro Area */}
                <div className="trust__header">
                    <p className="trust__eyebrow">
                        <Icon icon="solar:shield-check-linear" className="trust__eyebrow-icon" />
                        <span>Backed by real usage</span>
                    </p>
                    <h2 className="trust__title">
                        Trusted by focused bettors<br />and active crypto traders.
                    </h2>
                    <p className="trust__subtitle">
                        AiPredict sits on top of your favorite books and exchanges, helping you keep
                        a disciplined edge while the models watch the markets for you.
                    </p>
                </div>

                <div className="trust__content">
                    
                    {/* Left Column: Platform Integrations */}
                    <div className="trust__integrations">
                        <p className="trust__label">Plug AiPredict into platforms like</p>
                        <div className="trust__logos-grid">
                            <div className="trust__logo-chip">
                                <Icon icon="simple-icons:binance" className="trust__logo-icon" />
                                <span>Binance</span>
                            </div>
                            <div className="trust__logo-chip">
                                <Icon icon="simple-icons:bybit" className="trust__logo-icon" />
                                <span>Bybit</span>
                            </div>
                            <div className="trust__logo-chip">
                                <Icon icon="simple-icons:coinbase" className="trust__logo-icon" />
                                <span>Coinbase</span>
                            </div>
                            <div className="trust__logo-chip">
                                <Icon icon="simple-icons:SportyBet" className="trust__logo-icon" />
                                <span>SportyBet</span>
                            </div>
                            <div className="trust__logo-chip">
                                <Icon icon="simple-icons:stake" className="trust__logo-icon" />
                                <span>Stake</span>
                            </div>
                        </div>
                        <p className="trust__footnote">
                            <Icon icon="solar:info-circle-linear" style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                            Names and logos are for illustrative purposes only. AiPredict does not place bets or trades for you.
                        </p>
                    </div>

                    {/* Right Column: Live System Stats */}
                    <div className="trust__stats">
                        
                        {/* Stat 1 */}
                        <div className="trust__stat-card">
                            <div className="trust__stat-header">
                                <Icon icon="solar:cpu-bolt-linear" className="trust__stat-icon" />
                                <span>System Capacity</span>
                            </div>
                            <p className="trust__stat-value">1.8M+</p>
                            <p className="trust__stat-desc">
                                Daily model simulations scanning football fixtures and crypto pairs.
                            </p>
                        </div>

                        {/* Stat 2 */}
                        <div className="trust__stat-card">
                            <div className="trust__stat-header">
                                <Icon icon="solar:chart-line-up-linear" className="trust__stat-icon" />
                                <span>Edge Quality</span>
                            </div>
                            <p className="trust__stat-value">65%+</p>
                            <p className="trust__stat-desc">
                                Selections that pass strict confidence filters before reaching your dashboard.
                            </p>
                        </div>

                        {/* Stat 3 */}
                        <div className="trust__stat-card">
                            <div className="trust__stat-header">
                                <Icon icon="solar:globe-linear" className="trust__stat-icon" />
                                <span>Market Coverage</span>
                            </div>
                            <p className="trust__stat-value">25/10</p>
                            <p className="trust__stat-desc">
                                Major football leagues and core crypto pairs monitored 24/7.
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default TrustSection;